import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { getProp } from '@cp/utils/object';
import { FC, createContext, useContext } from 'react';

export type ResumeFeature = FC<CatalogItemViewModel> | FC<CatalogItemViewModel>[] | undefined;

export interface ResumeFeaturesSidebars {
  right?: ResumeFeature;
}

export interface IResumeFeaturesContext {
  sidebar?: ResumeFeaturesSidebars;
}

const ResumeFeaturesContext = createContext<IResumeFeaturesContext | null>(null);

export const useResumeFeatures = <T = unknown>(featurePath?: string): T => {
  const features = useContext(ResumeFeaturesContext);
  if (!features) {
    return null as T;
  }
  if (!featurePath) {
    return features as T;
  }
  return getProp(features, featurePath) as T;
};
export const ResumeFeaturesProvider = ResumeFeaturesContext.Provider;
